import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import {
  supplierTermsOfPayment,
  supplierPaymentMethods,
  supplierDeliveryTerms,
  supplierModeOfDelivery,
  indianSupplierGroups as supplierGroups,
  supplierCategories,
  commodityCodes,
  tdsApplicabilityOptions,
  tdsSections
} from '../../../utils/questionnaireOptions';

const IndianVendorQuestionnaire = ({ formData, updateFormData, errors }) => {
  const [openSelectId, setOpenSelectId] = useState(null);

  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });
  };

  return (
    <div className="space-y-8">
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-foreground mb-3">Vendor Questionnaire</h3>
        <p className="text-sm text-text-secondary">
          Please answer the following questions to complete the vendor approval process.
        </p>
      </div>

      {/* 2-Column Layout for better question distribution */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6">
        <Select
          label="1. Supplier Term of Payment"
          options={supplierTermsOfPayment}
          value={formData.supplierTermOfPayment}
          onChange={(value) => handleInputChange('supplierTermOfPayment', value)}
          error={errors.supplierTermOfPayment}
          required
          searchable
          open={openSelectId === 'supplierTermOfPayment'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'supplierTermOfPayment' : null)}
        />

        <Select
          label="2. Supplier Payment Method"
          options={supplierPaymentMethods}
          value={formData.supplierPaymentMethod}
          onChange={(value) => handleInputChange('supplierPaymentMethod', value)}
          error={errors.supplierPaymentMethod}
          required
          open={openSelectId === 'supplierPaymentMethod'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'supplierPaymentMethod' : null)}
        />

        <Select
          label="3. Supplier Delivery Terms"
          options={supplierDeliveryTerms}
          value={formData.supplierDeliveryTerms}
          onChange={(value) => handleInputChange('supplierDeliveryTerms', value)}
          error={errors.supplierDeliveryTerms}
          required
          open={openSelectId === 'supplierDeliveryTerms'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'supplierDeliveryTerms' : null)}
        />

        <Select
          label="4. Supplier Mode of Delivery"
          options={supplierModeOfDelivery}
          value={formData.supplierModeOfDelivery}
          onChange={(value) => handleInputChange('supplierModeOfDelivery', value)}
          error={errors.supplierModeOfDelivery}
          required
          open={openSelectId === 'supplierModeOfDelivery'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'supplierModeOfDelivery' : null)}
        />

        <Select
          label="5. Supplier Group"
          options={supplierGroups}
          value={formData.supplierGroup}
          onChange={(value) => handleInputChange('supplierGroup', value)}
          error={errors.supplierGroup}
          required
          searchable
          open={openSelectId === 'supplierGroup'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'supplierGroup' : null)}
        />

        <Select
          label="6. Supplier Category"
          options={supplierCategories}
          value={formData.supplierCategory}
          onChange={(value) => handleInputChange('supplierCategory', value)}
          error={errors.supplierCategory}
          required
          searchable
          open={openSelectId === 'supplierCategory'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'supplierCategory' : null)}
        />

        <Select
          label="7. Commodity Code"
          options={commodityCodes}
          value={formData.commodityCode}
          onChange={(value) => handleInputChange('commodityCode', value)}
          error={errors.commodityCode}
          required
          searchable
          className="lg:col-span-2"
          open={openSelectId === 'commodityCode'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'commodityCode' : null)}
        />

        {/* TDS — interim section; final field list is pending from management.
            Section/rate only apply when TDS is applicable. */}
        <Select
          label="8. TDS Applicable"
          options={tdsApplicabilityOptions}
          value={formData.tdsApplicable}
          onChange={(value) => handleInputChange('tdsApplicable', value)}
          error={errors.tdsApplicable}
          open={openSelectId === 'tdsApplicable'}
          onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'tdsApplicable' : null)}
        />

        {formData.tdsApplicable === 'YES' && (
          <>
            <Select
              label="9. TDS Section"
              options={tdsSections}
              value={formData.tdsSection}
              onChange={(value) => handleInputChange('tdsSection', value)}
              error={errors.tdsSection}
              searchable
              open={openSelectId === 'tdsSection'}
              onOpenChange={(isOpen) => setOpenSelectId(isOpen ? 'tdsSection' : null)}
            />

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                10. TDS Rate (%)
              </label>
              <input
                type="text"
                inputMode="decimal"
                value={formData.tdsRate}
                onChange={(e) => handleInputChange('tdsRate', e.target.value)}
                placeholder="e.g. 2, 0.1, 10"
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500"
              />
              {errors.tdsRate && <p className="mt-1 text-sm text-red-600">{errors.tdsRate}</p>}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default IndianVendorQuestionnaire; 